<template>
  <div id="paid-order" v-if="LastOrder && BranchDetail">
    <el-row class="back">
      <el-col :span="24" v-if="LastOrder.deliveryStatus != 100">
        <div class="close-icon-head" @click="closeOrder">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </el-col>
      <el-col :span="24" class="text-center paid-header">
        <h4 class="mb-0 text-title" v-if="LastOrder.deliveryStatus != 8 && LastOrder.deliveryStatus != 100">{{ $t('pageOrderDetail.thank') }}</h4>
        <div v-else style="height:50px"></div>
        <div class="text-heading3--bold color-info--text">Order no: {{ LastOrder.orderCode }}</div>
      </el-col>
    </el-row>
    <!-- Step Cancel -->
    <div class="p-r-l-20 fs-vh-100" v-if="LastOrder.deliveryStatus == 100">
      <el-row class="order-status">
        <el-col :span="24" class="text-center">
          <img class="order-icon-compelete" src="@/assets/icons/thank/cancelorder.png"> <br><br>
          <label class="complete-order-title cancelorder">{{ $t('pageOrderDetail.cancel') }}</label> <br>
          <label class="complete-order-text" v-if="LastOrder.rejectReason != '' && LastOrder.rejectReason == 'ร้านปิด'">{{ $t('pageOrderDetail.reason') }}: {{ ($i18n.locale === 'en') ? 'Closed' : LastOrder.rejectReason }}</label>
          <label class="complete-order-text" v-if="LastOrder.rejectReason != '' && LastOrder.rejectReason == 'รายการสินค้าหมด'">{{ $t('pageOrderDetail.reason') }}: {{ ($i18n.locale === 'en') ? 'Out of stock' :  LastOrder.rejectReason }}</label>
          <label class="complete-order-text" v-if="LastOrder.rejectReason != '' && LastOrder.rejectReason == 'งดส่งชั่วคราว'">{{ $t('pageOrderDetail.reason') }}: {{ ($i18n.locale === 'en') ? 'Temporarily closed' :  LastOrder.rejectReason }}</label>
          <label class="complete-order-text" v-if="LastOrder.rejectReason != '' && LastOrder.rejectReason.search('อื่นๆ') != -1">{{ $t('pageOrderDetail.reason') }}: {{ ($i18n.locale === 'en') ? LastOrder.rejectReason.replace("อื่นๆ", "Etc") : historylist.rejectReason }}</label>
          <div class="cancelorder-text" v-html="$t('pageOrderDetail.text1')"></div>
        </el-col>
      </el-row>
    </div>
    <!-- Step Normal -->
    <div class="p-r-l-20" v-else>
      <el-row class="order-status" v-if="LastOrder.deliveryStatus == 2 && LastOrder.confirmEditFlag == 1 || LastOrder.deliveryStatus == 5 || (LastOrder.deliveryStatus == 9 && LastOrder.confirmEditFlag == 1 && LastOrder.editType != 1)">
        <el-col :span="5" class="text-center">
          <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
          <p class="active mt--3 text-subtitle--med">{{ $t('pageOrderDetail.confirmorder') }}<br>{{ $t('drawer.editorder.order') }}</p>
        </el-col>
        <el-col :span="4" class="text-center">
          <div class="line"></div>
        </el-col>
        <el-col :span="5" class="text-center" >
          <img class="ico" v-if="LastOrder.deliveryStatus == 2 || LastOrder.deliveryStatus == 5" src="@/assets/icons/thank/preparing_active.png">
          <img class="ico" v-else src="@/assets/icons/thank/preparing_inactive.png">
          <p class="mt--3 text-subtitle--med" :class="(LastOrder.deliveryStatus == 2 || LastOrder.deliveryStatus == 5) ? 'active' : ''">{{ $t('pageOrderDetail.prepareorder') }}<br>{{ $t('drawer.editorder.order') }}</p>
        </el-col>
        <el-col :span="4" class="text-center">
          <div class="line"></div>
        </el-col>
        <el-col :span="5" class="text-center">
          <img class="ico" v-if="LastOrder.deliveryStatus == 5" src="@/assets/icons/thank/step3_active.png">
          <img class="ico" v-else src="@/assets/icons/thank/step3_interactive.png">
          <p class="mt--3 text-subtitle--med" :class="(LastOrder.deliveryStatus == 5) ? 'active' : ''">{{ $t('pageOrderListCurrent.orderalready') }}</p>
        </el-col>
      </el-row>
      <el-row v-else-if="LastOrder.deliveryStatus == 8" class="order-status m-b-20" >
        <el-col :span="24" class="text-center">
          <img class="order-icon-compelete" src="@/assets/icons/thank/orderpickedup.png"> <br>
          <label class="complete-order-title">{{ $t('pageOrderDetail.reciveorder') }}</label> <br>
          <label class="complete-order-text">{{ $t('pageOrderDetail.text2') }}</label>
        </el-col>
      </el-row>
      <!-- Step Edit Order -->
      <el-row class="py-22" v-else-if="LastOrder.deliveryStatus == 3 || (LastOrder.deliveryStatus == 9 && LastOrder.confirmEditFlag == 0 && LastOrder.editType != 1 ) || LastOrder.deliveryStatus == 2 && LastOrder.confirmEditFlag == 0 && LastOrder.editType == 2">
        <el-col>
          <label class="fs-warning text-subtitle"><i class="el-icon-warning-outline"></i> {{ $t('pageOrderListCurrent.editheader') }}</label>
        </el-col>
      </el-row>
      <div v-if="LastOrder.orderTypeDesc == 'Pickup'">
        <div class="text-heading2--med cl-brown-ligth-sec">
          {{ $t('pageOrderListHistory.pickup') }}
        </div>
        <div class="cl-brown-ligth"> 
          <span class="text-heading3--bold">{{ $t('pageCheckout.customer') }}</span>:  
          <span class="text-heading3 ml--2">{{ LastOrder.customerName }} • {{ LastOrder.phoneNumber }}</span>
        </div>
        <div class="cl-brown-ligth"> 
          <span class="text-heading3--bold">{{ $t('drawer.paiddetail.orderdate') }}</span>:  
          <span class="text-heading3 ml--2">{{ LastOrder.createDt }}</span>
        </div>
        <!-- Preorder Time -->
        <el-row class="my-2 d-flex align-center" v-if="LastOrder.isPreorder">
          <i class="el-icon-time fs-time"></i>
          <label class="ml--2" v-if="isToday(LastOrder.orderedTime.date)">
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
            {{ $t('pageCheckout.deliverytime') }} :
            </em> 
            <span class="text-heading3">
              {{ $t('dialog.preorder.today') }}, 
              {{ LastOrder.orderedTime.date }}
            </span>
          </label>
          <label class="ml--2" v-else>
              <em class="text-heading3--bold fs-st-n cl-brown-ligth">
                {{ $t('pageCheckout.deliverytime') }} : 
              </em>
              <span class="text-heading3">
                {{ ($i18n.locale === 'en') ? this.filter_long_day_en(LastOrder.orderedTime.dayList) : this.filter_long_day_th(LastOrder.orderedTime.dayList) }}, {{ LastOrder.orderedTime.date }}
              </span>
          </label>
        </el-row>
        <!-- Edit Order Time Only -->
        <el-row class="my-2 d-flex align-center" v-else-if="LastOrder.editType != 1">
          <i class="el-icon-time fs-time"></i>
          <label class="ml--2">
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('drawer.editorder.pickuptime') }} :
            </em>
            <span class="text-heading3">
              {{ LastOrder.orderedTime.date }}
            </span>
          </label>
        </el-row>
        <!-- Order Now -->
        <el-row class="my-2 d-flex align-center" v-else>
          <i class="el-icon-time fs-time"></i>
          <label 
            class="ml--2 text-heading3" 
            v-if="LastOrder.estimatedTime == 0"
          >
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('pageCheckout.deliverytime') }} :
            </em> 
            <span class="text-heading3">
              {{ $t('pageCheckout.deliverynow') }}
            </span>
          </label>
          <label class="ml--2 text-heading3" v-else>
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('pageCheckout.deliverytime') }} : 
            </em>
            <span class="text-heading3">
              {{ $t('pageCheckout.deliverynow') }} ({{ $t('pageOrderListCurrent.around') }} {{ LastOrder.estimatedTime }} {{ $t('pageOrderListCurrent.minute') }})
            </span>
          </label>
        </el-row>
        <el-row class="m-t-17 d-flex">
          <el-col :span="7" class="pr--2">
            <Gmap
              :position="{ lat: BranchDetail.latitude, lng: BranchDetail.longitude }" 
              :marker-icon="require('@/assets/icons/svg/pin.svg')"
              :marker-size="{ height: 50, width: 50 }"
              :zoom="16"
              :readonly="true"
              height="90px"
              style="border-radius: 8px;"
            />
          </el-col>
          <el-col :span="16" class="pl--1">
            <div>
              <label class="text-heading2--bold">
                {{ $t('pageCheckout.restaurant') }} {{ BranchDetail.restaurantName }} {{ $t('pageCheckout.branch') }} {{ BranchDetail.name }}
              </label>
            </div>
            <div class="pt--1">
              <label class="text-body color-charcoal--text">
                {{ BranchDetail.address }}
              </label>
              <span v-if="distanceInfo" class="text-body color-info--text">
                ({{ distanceInfo.dis_metre }} {{ $t('global.kilometer') }})
              </span>
            </div>
            <!-- <br/> -->
            <!-- <a class="text-grey text-subtitle" target="_blank" :href="'https://www.google.com/maps/search/?api=1&query='+ BranchDetail.latitude +',' + BranchDetail.longitude">{{ $t('pageCheckout.findmap') }} <i class="el-icon-arrow-right"></i></a> -->
          </el-col>
          <!-- <el-col 
						:span="3" 
						class="text-xs-center self-ys-center" 
					>
						<a 
              :href="'https://www.google.com/maps/search/?api=1&query='+ BranchDetail.latitude +',' + BranchDetail.longitude"
              target="_blank"
            >
							<img 
								:src="require('@/assets/icons/svg/direction-circle.svg')"
								alt="google-map-link"
							/>
						</a>
					</el-col> -->
        </el-row>
      </div>
      <div v-else>
        <div class="pb--2">
          <label class="text-heading2--med cl-brown-ligth-sec">
            {{ $t('pageMenuList.header.deliveryFlag') }}
          </label>
        </div>
        <div class="cl-brown-ligth"> 
          <span class="text-heading3--bold">{{ $t('pageCheckout.customer') }}</span> :  
          <em class="text-heading3 fs-st-n cl-brown-ligth">
            {{ LastOrder.customerName }} • {{ LastOrder.phoneNumber }}
          </em>
        </div>
        <div class="cl-brown-ligth"> 
          <span class="text-heading3--bold">{{ $t('drawer.paiddetail.orderdate') }}</span> :  
          <em class="text-heading3 fs-st-n cl-brown-ligth">{{ LastOrder.createDt }}</em>
        </div>
        <!-- Preorder Time -->
        <el-row class="my-2" v-if="LastOrder.isPreorder">
          <i class="el-icon-time fs-time"></i>
          <label 
            class="ml--2"
            v-if="isToday(LastOrder.orderedTime.date)"
          >
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('pageCheckout.deliverytime') }} :
            </em> 
            <span class="text-heading3">
              {{ $t('dialog.preorder.today') }}, {{ LastOrder.orderedTime.date }}
            </span>
          </label>
          <label class="ml--2" v-else>
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">{{ $t('pageCheckout.deliverytime') }}: </em>
            <span class="text-heading3">
              {{ ($i18n.locale === 'en') ? 
                this.filter_long_day_en(LastOrder.orderedTime.dayList) : 
                this.filter_long_day_th(LastOrder.orderedTime.dayList) }}
                , {{ LastOrder.orderedTime.date }}
            </span>
          </label>
        </el-row>
        <!-- Edit Order Time Only -->
        <el-row class="my-2" v-else-if="LastOrder.editType != 1">
          <i class="el-icon-time fs-time"></i>
          <label class="ml--2">
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">{{ $t('drawer.editorder.deliverytime') }} : </em>
            <span class="text-heading3">
              {{ LastOrder.orderedTime.date }}
            </span>
          </label>
        </el-row>
        <!-- Order Now -->
        <el-row class="my-2 d-flex align-center" v-else>
          <i class="el-icon-time fs-time"></i>
          <div class="ml--2" v-if="LastOrder.estimatedTime == 0">
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('pageCheckout.deliverytime') }} :
            </em> 
            <span class="text-heading3">{{ $t('pageCheckout.deliverynow') }}</span>
          </div>
          <div class="ml--2" v-else>
            <em class="text-heading3--bold fs-st-n cl-brown-ligth">
              {{ $t('pageCheckout.deliverytime') }}: 
            </em>
            <span class="text-heading3">
              {{ $t('pageCheckout.deliverynow') }} ({{ $t('pageOrderListCurrent.around') }} 
              {{ LastOrder.estimatedTime }} {{ $t('pageOrderListCurrent.minute') }})
            </span>
          </div>
        </el-row>
        <el-row class="address">
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/from_res.png" class="icon-from">
          </el-col>
          <el-col :span="22"><div class="from-text text-body">{{ LastOrder.restaurantName }} {{ $t('pageCheckout.branch') }} {{ LastOrder.branchName }}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/dot.png" width="2" height="20" class="">
            <el-col :span="22"></el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/pin.png" class="icon-from">
          </el-col>
          <el-col :span="22"><div class="from-text text-body">{{ LastOrder.address }}</div></el-col>
        </el-row>
      </div>
      <el-row v-if="LastOrder.addressNote !== ''" class="py--3">
        <el-col class="text-heading3--bold">
          <label class="text-heading3-bold">
            {{ 
              LastOrder.orderTypeDesc == 'Pickup' ? 
                $t('pageOrderListHistory.note') : 
                $t('drawer.paiddetail.notedriver') 
            }}
          </label>
        </el-col>
        <el-col>
          <label class="text-grey text-heading3">{{ LastOrder.addressNote }}</label>
        </el-col>
      </el-row>
      <div :class="(LastOrder.addressNote == '') ? 'fs-bd-b pb-2 pt-2' : 'fs-bd-b'"></div>
      <el-row class="py-2 fs-bd-b fs-entry-wrap" v-for="(menu,i) in LastOrder.menus" :key="'menu-'+i">
        <el-col :span="18">
          <label class="text-heading2--med cl-brown-ligth-sec"><span class="fs-link">{{menu.quantity}}x</span> {{menu.name}}</label>
          <el-col v-for="(goption,i) in menu.optionGroups" :key="'option-'+i">
            <li 
              class="text-grey text-heading3" 
              v-for="(option,j) in goption.options" 
              :key="'option-'+j"
            >
              {{ option.name }} {{ (option.quantity > 1) ? 'x' + option.quantity : '' }}
            </li>
          </el-col>
          <el-col>
              <label class="notaion">{{menu.note}}</label>
          </el-col>
        </el-col>
        <el-col class="text-right" :span="6">
          <span class="text-heading2--med cl-brown-ligth-sec">{{ menu.price | priceFormat(0,currency) }}</span>
        </el-col>
      </el-row>
      <div id="checkout-cart-price">
        <el-row class="pt-2">
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">{{ $t('pageCheckout.subtotal') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3 cl-brown-ligth">{{ LastOrder.subTotal | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <el-row v-if="LastOrder.orderTypeDesc != 'Pickup'">
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth" v-if="LastOrder.distance === ''">{{ $t('suggestion.delivery') }} (0 km.)</label>
            <label class="text-heading3 cl-brown-ligth" v-else>{{ $t('suggestion.delivery') }} ({{ LastOrder.distance }} km.)</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3 cl-brown-ligth" v-if="LastOrder.fee > 0">{{ LastOrder.fee | priceFormat(0,currency) }}</label>
            <label class="fs-price-free" v-else>{{ $t('pageCheckout.free') }}</label>
          </el-col>
        </el-row>
        <el-row v-if="BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00' && LastOrder.vat != '0.00'">
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">Vat ({{ LastOrder.tax | priceFormat }}%)</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3 cl-brown-ligth">{{ LastOrder.vat | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <el-row class="pb-2">
          <el-col :span="12">
            <label class="text-heading--bold cl-brown-ligth-sec">{{ $t('pageCheckout.totalAmount') }}</label>
          </el-col>
          <el-col class="text-right" :span="12">
            <label class="text-heading--bold cl-brown-ligth-sec">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <!-- รายละเอียดแก้ไข -->
        <!-- Cash -->
        <el-row v-if="(LastOrder.isPaid == 0 || LastOrder.isPaid == 1) && LastOrder.orderUpdateTime != '' && LastOrder.paymentType == 1 && LastOrder.editType != 2" >
          <div class="fs-bd-b"></div>
          <el-col class="py-22">
            <label class="text-heading2--med cl-brown-ligth-sec">{{ $t('pageOrderDetail.detailedit') }}</label>
          </el-col>
          <el-col class="pb-2">
            <el-row>
              <el-col :span="12">
                <label class="text-subtitle cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-subtitle cl-brown-ligth">{{ LastOrder.origTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <label class="fs-link text-subtitle--bold">{{ $t('drawer.editorder.newprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="fs-link text-subtitle--bold">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label><br>
                <label v-if="origTotalAmount < totalAmount" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">+ {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount > totalAmount" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">- {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount == totalAmount" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.nondiff1') }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- Transfer Case isPaid = 1 && Refund = 0, 1, 2 -->
        <el-row v-if="LastOrder.isPaid == 1 && LastOrder.refundStatus != 3 && LastOrder.orderUpdateTime != '' && LastOrder.paymentType == 2 && LastOrder.editType != 2">
          <div class="fs-bd-b"></div>
          <el-col class="pt-2">
            <label class="text-heading--bold">{{ $t('pageOrderDetail.detailedit') }}</label>
          </el-col>
          <el-col class="pt-2 pb-2">
            <el-row>
              <el-col :span="12">
                <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label v-if="LastOrder.refundStatus == 0 || LastOrder.refundStatus == 2 && origTotalAmount < totalAmount" class="text-subtitle cl-gray-ligth-thrd"><em class="fs-price-success">{{ $t('drawer.editorder.paid') }}</em></label>
                <label class="text-heading3 cl-brown-ligth">{{ LastOrder.origTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <label class="text-heading3--bold cl-brown-ligth">{{ $t('drawer.editorder.newprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading3--bold cl-brown-ligth">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <!-- Transfer Customer Pay More -->
            <el-row v-if="LastOrder.refundStatus == 0 && origTotalAmount < totalAmount">
              <div class="fs-bd-b"></div>
              <el-col :span="12" class="py-2">
                <label class="fs-link text-heading--bold">{{ $t('without.text6') }}</label>
              </el-col>
              <el-col :span="12" class="text-right py-2">
                <label class="fs-link text-heading--bold">{{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <!-- Transfer Customer Wait Refund -->
            <el-row v-if="LastOrder.refundStatus == 0 && origTotalAmount > totalAmount">
              <div class="fs-bd-b"></div>
              <el-col :span="12" class="py-2">
                <label class="fs-refund text-heading--bold">{{ $t('drawer.editorder.refund') }}</label>
              </el-col>
              <el-col :span="12" class="text-right py-2">
                <label class="fs-refund text-heading--bold">
                  <em class="fw-sm fs-price-warning mr--1">
                    <i class="el-icon-refresh-right"></i> 
                    {{ $t('pageOrderDetail.waitrefund') }}
                  </em> 
                  {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}
                </label>
              </el-col>
            </el-row>
            <!-- Transfer Customer Success Refund -->
            <el-row v-if="LastOrder.refundStatus == 1 && origTotalAmount > totalAmount">
              <div class="fs-bd-b"></div>
              <el-col :span="12" class="py-2">
                <label class="cl-brown-ligth-sec text-heading3">{{ $t('drawer.editorder.refund') }}</label>
              </el-col>
              <el-col :span="12" class="text-right py-2">
                <label class="cl-brown-ligth-sec text-heading3--bold"><em class="fs-refund-success"><i class="el-icon-refresh-right"></i> {{ $t('pageOrderDetail.successrefund') }}</em> {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <!-- Transfer Not Diff -->
            <el-row v-if="origTotalAmount == totalAmount">
              <div class="fs-bd-b"></div>
              <el-col class="py-2 text-center">
                <label class="fs-link text-heading">{{ $t('drawer.editorder.descriptnondiff1') }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- Transfer Case isPaid = 1 && Refund = 3 -->
        <el-row v-if="LastOrder.isPaid == 1 && LastOrder.refundStatus == 3 && LastOrder.orderUpdateTime != '' && LastOrder.paymentType == 2 && LastOrder.editType != 2">
          <div class="fs-bd-b"></div>
          <el-col class="pt-4">
            <label class="text-heading--bold cl-brown-ligth-sec">{{ $t('pageOrderDetail.detailedit') }}</label>
          </el-col>
          <el-col>
            <el-row class="fs-bd-b pt-2 pb-2">
              <el-col :span="12">
                <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading3 cl-brown-ligth">{{ LastOrder.origTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <el-row class="pt-2 pb-2">
              <el-col :span="12">
                <label class="text-heading--bold fs-link">{{ $t('drawer.editorder.newprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading--bold fs-link">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label><br>
                <label v-if="origTotalAmount < totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">+ {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount > totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">- {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount == totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.nondiff1') }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- Transfer Case isPaid = 0 && Refund = 0, 1, 2 -->
        <el-row v-if="LastOrder.isPaid == 0 && LastOrder.refundStatus != 3 && LastOrder.orderUpdateTime != '' && LastOrder.paymentType == 2 && LastOrder.editType != 2">
          <div class="fs-bd-b"></div>
          <el-col class="pt-2">
            <label class="text-heading--bold">{{ $t('pageOrderDetail.detailedit') }}</label>
          </el-col>
          <el-col class="py-2">
            <el-row>
              <el-col :span="12">
                <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <!-- <label class="fs-14 fw-sm cl-gray-ligth-thrd"><em class="fs-price-success">ชำระแล้ว</em></label> -->
                <label class="text-heading3 cl-brown-ligth">{{ LastOrder.origTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <label class="text-heading--bold cl-brown-ligth">{{ $t('drawer.editorder.newprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading--bold cl-brown-ligth">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <el-row>
              <div class="fs-bd-b"></div>
              <el-col :span="12" class="py-2">
                <label class="fs-link text-heading--bold">{{ $t('without.text6') }}</label>
              </el-col>
              <el-col :span="12" class="text-right py-2">
                <label class="fs-link text-heading--bold">{{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- Transfer Case isPaid = 0 && Refund = 3 -->
        <el-row v-if="LastOrder.isPaid == 0 && LastOrder.refundStatus == 3 && LastOrder.orderUpdateTime != '' && LastOrder.paymentType == 2 && LastOrder.editType != 2">
          <div class="fs-bd-b"></div>
          <el-col class="pt-4">
            <label class="text-heading--bold cl-brown-ligth-sec">{{ $t('pageOrderDetail.detailedit') }}</label>
          </el-col>
          <el-col>
            <el-row class="fs-bd-b pt-2 pb-2">
              <el-col :span="12">
                <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <!-- <label v-if="LastOrder.isPaid == 1" class="text-subtitle cl-brown-ligth"><em class="fs-14 fw-md fs-price-success">ชำระแล้ว</em></label> -->
                <label class="text-heading3 cl-brown-ligth">{{ LastOrder.origTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
            <el-row class="pt-2 pb-2">
              <el-col :span="12">
                <label class="text-heading--bold fs-link">{{ $t('drawer.editorder.newprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading--bold fs-link">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label><br>
                <label v-if="origTotalAmount < totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">+ {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount > totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">- {{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</em></label>
                <label v-if="origTotalAmount == totalAmount" class="text-heading3 cl-gray-ligth-thrd">{{ $t('drawer.editorder.nondiff2') }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div class="fs-bd-b"></div>
        <!-- Transfer Case isPaid = 1 && Refund = 0 -->
        <el-row class="py-22" v-if="LastOrder.isPaid == 1 && LastOrder.refundStatus == 0 && LastOrder.paymentType == 2 && origTotalAmount > totalAmount">
          <el-col>
            <label class="text-body cl-gray-ligth-four">*{{ $t('drawer.editorder.refundtext') }}</label>
          </el-col>
        </el-row>
        <!-- ชำระเงินปลายทาง -->
        <el-row class="py-2" v-if="LastOrder.paymentType == 1">
          <el-col :span="7">
            <label width="20" class="text-body cl-gray-ligth-sec">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="17">
            <div class="d-flex align-center">
              <img src="@/assets/icons/thank/cash.png" class="icon-from">
              <label class="text-body ml--2 cl-brown-ligth-sec">
                {{ $t('pageCheckout.cod') }}
              </label>
            </div>
          </el-col>
        </el-row>
        <!-- คิวอาร์ -->
        <el-row class="py-2" v-if="LastOrder.paymentType == 17">
          <el-col :span="7">
            <label width="20" class="text-body cl-gray-ligth-sec">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="17">
            <el-row>
              <el-col class="d-flex align-center" :span="10">
                <img src="@/assets/icons/thank/icon-promptpay.png" class="icon-from">
                <label class="ml--2 text-body cl-brown-ligth-sec">
                  QR
                </label>
              </el-col>
              <el-col :span="14" class="text-right">
                <div v-if="LastOrder.isPaid == 0">
                  <label class="text-body fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else class="fs-16 fw-md fs-success">
                  <label class="text-body fs-success">• {{ $t('drawer.editorder.paid') }}</label>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- เครดิต -->
        <el-row class="py-2 d-flex align-center" v-if="LastOrder.paymentType == 18">
          <el-col :span="7">
            <label width="20" class="price-tag text-body">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="17">
            <el-row class="d-flex align-center">
              <el-col class="d-flex align-center" :span="14">
                <img class="fs-credit-icon" :src="'https://images.foodstory.co/' + LastOrder.imageCreditCard">
                <label class="ml--2 text-heading2--med fs-al-sp">
                  **** {{ LastOrder.numberCreditCard }}
                </label>
              </el-col>
              <el-col :span="10" class="text-right">
                <div v-if="LastOrder.isPaid == 0">
                  <label class="text-heading3--med fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else>
                  <label class="text-heading3--med fs-success">• {{ $t('drawer.editorder.paid') }}</label>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- โอน -->
        <div class="py-2" v-if="LastOrder.paymentType == 2 && LastOrder.payment">
          <div v-for="payment in LastOrder.payment" :key="'bank-'+payment.branch_bank_account_id">
            <el-row class="d-flex align-center">
              <el-col :span="6" >
                <label class="text-body cl-gray-ligth-sec">{{ $t('pageCheckout.payment') }}</label>
              </el-col>
              <el-col :span="10" class="d-flex align-center">
                <img width="20" height="20" class="fs-circle mb--1" :src="'https://images.foodstory.co/'+payment.image_key">
                <label class="ml--2 text-body fs-al-tt cl-brown-ligth-sec">{{payment.bank_name}}</label>
              </el-col>
               <el-col :span="8" class="text-right">
                <div v-if="LastOrder.slipStatus">
                  <label class="text-heading3--med fs-wait">• {{ $t('pageOrderListCurrent.recheckslip') }}</label>
                </div>
                <div v-else-if="(LastOrder.isPaid == 1) && LastOrder.orderUpdateTime != '' && LastOrder.refundStatus == 0 && origTotalAmount < totalAmount && !LastOrder.slipStatus">
                  <label class="text-heading3--med fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else-if="LastOrder.isPaid == 0 && !LastOrder.slipStatus">
                  <label class="text-heading3--med fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else-if="LastOrder.isPaid == 1 && !LastOrder.slipStatus">
                  <label class="text-heading3--med fs-success">• {{ $t('drawer.editorder.paid') }}</label>
                </div>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <div>
                  <img width="20" height="20" class="fs-circle fl-left" :src="'https://images.foodstory.co/'+payment.image_key">
                  <label class="ml--1 text-subtitle fs-al-tt cl-brown-ligth-sec">{{payment.bank_name}}</label>
                </div>
              </el-col>
              <el-col class="text-right" :span="12">
                <div v-if="LastOrder.slipStatus">
                  <label class="text-subtitle--med fs-wait">• {{ $t('pageOrderListCurrent.recheckslip') }}</label>
                </div>
                <div v-else-if="(LastOrder.isPaid == 1) && LastOrder.orderUpdateTime != '' && LastOrder.refundStatus == 0 && origTotalAmount < totalAmount && !LastOrder.slipStatus">
                  <label class="text-subtitle--med fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else-if="LastOrder.isPaid == 0 && !LastOrder.slipStatus">
                  <label class="text-subtitle--med fs-wait">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                </div>
                <div v-else-if="LastOrder.isPaid == 1 && !LastOrder.slipStatus">
                  <label class="text-subtitle--med fs-success">• {{ $t('drawer.editorder.paid') }}</label>
                </div>
              </el-col>
            </el-row> -->
            <el-row class="py--2">
              <el-col :span="24">
                <label class="text-heading3 cl-brown-ligth-sec">
                  {{ $t('pageCheckout.accountname') }}: 
                  {{payment.account_name}}
                </label>
              </el-col>
              <el-col :span="18" >
                <label class="text-heading3 cl-brown-ligth-sec">
                  {{ $t('pageCheckout.accountnumber') }}: 
                  <span class="text-heading3--bold">
                    {{payment.account_number}}
                  </span>
                </label>
              </el-col>
              <el-col :span="6" class="text-right">
                <el-button plain @click="copyHandle(payment.account_number)" class="copy-btn text-link">{{ $t('pageCheckout.copy') }}</el-button>
              </el-col>
            </el-row>
            <el-row v-if="LastOrder.slipStatus">
              <label class="text-heading3--med fs-link fs-t-ul" @click="toggle_edit_order_transfer">{{ $t('pageOrderDetail.seeslip') }}</label>
            </el-row>
          </div>
        </div>
        <!-- ติดต่อร้าน -->
        <div class="fs-bd-b"></div>
        <div id="contact" class="py-2">
          <div class="text-heading2--med">{{ $t('drawer.paiddetail.contactbranch') }}</div>
            <el-row class="order-status">
              <el-col :span="contactCol" class="text-center"  v-if="BranchDetail.fbMessenger">
                <img class="ico" src="@/assets/icons/thank/messenger.png" @click="openLink(BranchDetail.fbMessenger)">
                <p class="text-heading3 color-black--text">Messenger</p>
              </el-col>
              <el-col :span="contactCol" class="text-center" v-if="BranchDetail.lineName">
                <img class="ico" src="@/assets/icons/thank/line.png" @click="openLink(BranchDetail.lineName,{from:'line',action: 'contact_branch'})">
                <p class="text-heading3 color-black--text">LINE</p>
              </el-col>
              <el-col :span="contactCol" class="text-center" v-if="BranchDetail.phone">
                <a :href="'tel:'+BranchDetail.phone"><img class="ico" src="@/assets/icons/thank/call.png"></a>
                <p class="text-heading3 color-black--text">{{ $t('pageRestaurant.tel') }}</p>
              </el-col>
            </el-row>
        </div>
        <!-- {{LastOrder}} -->
        <div v-if="this.branch_queue_permission.includes(this.LastOrder.branch_id) && ![0,7,8].includes(LastOrder.deliveryStatus) && LastOrder.orderType == 2" id="queue" class="py-2">
          <el-row class="order-status">
            <fullButton :handleClick="openQueuePage" :btn_text="$t('drawer.queue.checkqueue')"/>
          </el-row>
        </div>
        <!-- สนใจใช้งานเว็บไชต์ -->
        <div id="foodstory-footer" class="text-left block pb-4">
          <span class="text-heading3">
            {{ $t('pageOrderDetail.footer') }}
          </span>
          <br>
          <el-row>
            <el-col :span="12">
              <img class="mt--2" src="@/assets/icons/logo_fs.png" width="88" height="19">
            </el-col>
            <el-col :span="12" class="text-right">
              <BaseButton 
                class="color-primary--text text-heading3 color-primary--border py--1 px--6 mb--2"
                @click="openLink('https://bit.ly/onlineorderfootpage')"
              >
                {{ $t('pageOrderDetail.contact') }}
              </BaseButton>
            </el-col>
          </el-row>
        </div>
      </div>
     </div>
    <!-- Action Button -->
    <!-- Cash -->
    <div class="confirm-paid" v-if="LastOrder.paymentType == 1 && LastOrder.deliveryStatus != 100">
      <fullButton v-if="LastOrder.orderUpdateTime !== '' && LastOrder.confirmEditFlag == 0 && LastOrder.editType != 2" :handleClick="confirmEditOrder" :btn_text="$t('dialog.confirm')" />
      <fullButton v-else :handleClick="closeOrder" :btn_text="$t('pageOrderDetail.close')" />
    </div>
    <!-- Transfer Edit Order -->
    <div class="confirm-paid" v-else-if="LastOrder.paymentType == 2 && LastOrder.orderUpdateTime !== '' && LastOrder.deliveryStatus != 100">
      <fullButton v-if="LastOrder.isPaid == 0 && LastOrder.confirmEditFlag == 1 && !LastOrder.slipStatus" :handleClick="toggle_edit_order_transfer" :btn_text="$t('drawer.editorder.totalprice') + ' '+  price_format(LastOrder.totalAmount,currency)" />
      <fullButton v-else-if="LastOrder.isPaid == 0 && LastOrder.confirmEditFlag == 0" :handleClick="confirmEditOrder" :btn_text="$t('dialog.confirm')" />
      <fullButton v-else-if="LastOrder.isPaid == 1 && LastOrder.confirmEditFlag == 1 && LastOrder.refundStatus == 0 && origTotalAmount < totalAmount && !LastOrder.slipStatus" :handleClick="toggle_edit_order_transfer" :btn_text="$t('pageOrderDetail.payrefund') + ' ' +  price_format(LastOrder.diffTotalAmount,currency)" />
      <fullButton v-else-if="LastOrder.isPaid == 1 && LastOrder.confirmEditFlag == 0" :handleClick="confirmEditOrder" :btn_text="$t('dialog.confirm')" />
      <fullButton v-else :handleClick="closeOrder" :btn_text="$t('pageOrderDetail.close')" />
    </div>
    <!-- QR -->
    <div class="confirm-paid" v-else-if="LastOrder.paymentType == 17 && LastOrder.isPaid == 0">
      <fullButton :handleClick="closeOrder" v-if="LastOrder.deliveryStatus == 100" :btn_text="$t('pageOrderDetail.close')" />
      <fullButton :handleClick="repeatPaymentQR" v-else :btn_text="$t('drawer.editorder.payment')" />
    </div>
    <!-- ETC. -->
    <div class="confirm-paid" v-else>
      <fullButton 
        :handleClick="closeOrder" 
        v-if="LastOrder.isPaid == 1 || LastOrder.deliveryStatus == 100 || LastOrder.deliveryStatus == 8" 
        :btn_text="$t('pageOrderDetail.close')" 
      />
      <fullButton 
        :handleClick="toggle_edit_order_transfer" 
        v-else-if="LastOrder.isPaid == 0 && LastOrder.paymentType == 2 && LastOrder.deliveryStatus != 3 && !LastOrder.slipStatus" 
        :btn_text="$t('pageOrderHistory.sendtransfer') + ' ' +  price_format(LastOrder.totalAmount,currency)" 
      />
      <fullButton 
        :handleClick="closeOrder" 
        v-else-if="LastOrder.isPaid == 0 && LastOrder.paymentType == 2 && LastOrder.deliveryStatus != 3 && LastOrder.slipStatus" 
        :btn_text="$t('pageOrderDetail.close')" 
      />
      <fullButton 
        :handleClick="closeOrder" 
        v-else-if="LastOrder.isPaid == 1 && LastOrder.paymentType == 2 && LastOrder.deliveryStatus != 3" 
        :btn_text="$t('pageOrderDetail.close')" 
      />
    </div>
    <!-- Drawer Payment Order -->
    <el-drawer
      class="fs-credit-drawer pb-0"
      id="chanel-confirm"
      :visible.sync="isOpenDrawerBankDetail"
      :direction="'btt'"
      :size="'90%'"
      :with-header="false">
      <el-row>
        <!-- Upload Slip Success -->
        <el-col v-if="isOpenDrawerUploadStatus">
          <el-row class="fs-site text-center" style="height: 80vh;">
            <el-col class="fs-content" style="
              margin: 0;
              position: absolute;
              top: 40%;
              left: 50%;
              -ms-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
            ">
              <img width="120" :src="require(`@/assets/icons/${ $i18n.locale == 'th' ? 'upload-sucess.jpg':'upload-success-en.png' }`)" /><br>
              <label class="text-title--large">{{ $t('pageOrderHistory.sendtransfer') }}</label><br>
              <label class="text-heading3 cl-gray-ligth-sec" v-html="$t('pageOrderHistory.branchreciveslip')"></label>
              <!-- <label class="fs-14 cl-gray-ligth-sec">ทางร้านได้รับหลักฐาน</label><br>
              <label class="fs-14 cl-gray-ligth-sec"> การชำระเงินแล้ว</label> -->
            </el-col>
            <el-col class="fs-credit-footer pb-0 px-0 fs-pos-ab">
              <fullButton :handleClick="closeUploadSlip" :btn_text="$t('pageOrderDetail.close')" />
            </el-col>
          </el-row>
        </el-col>
        <!-- Upload Slip -->
        <el-col v-else>
          <el-row class="fs-header">
            <el-col :span="10">
              <label class="text-heading2--bold">{{ $t('pageCheckout.payment') }}</label>
            </el-col>
            <el-col :span="14" class="text-right">
              <label class="fs-link fs-16 text-heading2--med" @click="toggle_edit_order_transfer">{{ $t('pageOrderHistory.orderdetail') }}</label>
            </el-col>
          </el-row>
          <el-row class="fs-site mt-2" v-if="LastOrder.paymentType == 2 && LastOrder.payment">
            <el-col class="fs-content mb-5">
              <el-row>
                <el-col>
                  <img class="fs-circle fs-al-sb" width="25" height="25" :src="'https://images.foodstory.co/'+ LastOrder.payment[0].image_key">
                  <label class="text-subtitle">{{ $t('drawer.editorder.transfer') }} {{ LastOrder.payment[0].bank_name }}</label>
                </el-col>
              </el-row>
              <el-row class="fs-bd-b py--3">
                <el-col :span="16">
                  <label class="text-subtitle cl-brown-ligth">{{ $t('pageCheckout.accountname') }}: {{ LastOrder.payment[0].account_name }}</label><br>
                  <label class="text-subtitle cl-brown-ligth">{{ $t('pageCheckout.accountnumber') }}: <em class="fw-lg fs-st-n">{{ LastOrder.payment[0].account_number }}</em></label>
                </el-col>
                <el-col :span="8" class="text-right">
                  <el-button plain @click="copyHandle(LastOrder.payment[0].account_number)" class="copy-btn text-link">{{ $t('pageCheckout.copy') }}</el-button>
                </el-col>
              </el-row>
              <el-row class="fs-bd-b py-2">
                <el-col :span="12">
                  <label class="text-heading2 cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
                </el-col>
                <el-col :span="12" class="text-right">
                  <label v-if="LastOrder.isPaid == 0" class="text-title--large cl-brown-ligth">{{ LastOrder.totalAmount | priceFormat(0,currency) }}</label>
                  <label v-else class="text-title--large cl-brown-ligth">{{ LastOrder.diffTotalAmount | priceFormat(0,currency) }}</label>
                </el-col>
              </el-row>
              <el-row class="pt-4">
                <el-col v-bind:class="(DataFiles === null && LastedimageSlipURL == '') ? 'fs-upload-border': 'pa-0'" @click.native="dropImageSlip">
                  <el-row v-if="DataFiles === null && LastedimageSlipURL == ''">
                    <i class="fs-50 fs-link el-icon-upload"></i><br>
                    <label class="text-heading2 fs-link">{{ $t('pageOrderHistory.sliptransfer') }}</label><br>
                    <label class="text-body cl-brown-ligth">*{{ $t('pageOrderHistory.textsliptranfer1') }}</label><br>
                    <label class="text-body cl-brown-ligth">{{ $t('pageOrderHistory.textsliptranfer2') }}</label>
                  </el-row>
                  <el-row>
                    <el-col>
                      <button v-if="DataFiles !== null || LastedimageSlipURL != ''" class="text-button fs-edit-slip fs-border-none"><i class="el-icon-edit"></i> {{ $t('pageOrderHistory.editimage') }}</button>
                      <img class="fs-bd-r-12" v-if="LastedimageSlipURL != ''" id="previewSlip" :src="LastedimageSlipURL" width="100%" height="100%">
                      <img v-else id="previewSlip" src="">
                    </el-col>
                  </el-row>
                </el-col>
                <input
                  id="imageSlip"
                  type="file"
                  style="display: none"
                  ref="imageSlip"
                  accept="image/*"
                  v-on:change="previewFile($event)"
                >
              </el-row>
            </el-col>
            <el-col class="fs-stick fs-credit-footer pb-0 px-0">
              <fullButton @click.native="confirmUploadSlip(DataFiles)" :display="(DataFiles === null) ? true : false" :btn_text="$t('pageOrderHistory.textuploadslip1')" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-drawer>
    <!-- Dialog EditOrder -->
    <DrawerEditOrder
      v-if="isOpenDrawerEditOrder"
      @toggle_edit_order="toggle_edit_order"
      @toggle_edit_order_transfer="toggle_edit_order_transfer"
      :confirm="confirm"
      :status="status"
      :page="'orderdetail'"
      :restaurant_uuid="restaurant_uuid"
      :branch_uuid="branch_uuid"
      :drawerData="LastOrder"
    />
  </div>
</template>

<script>
import DrawerEditOrder from './DrawerEditOrder'
import Mixins from '@/utils/mixins'

import Gmap from '@/components/element/Gmap.vue'
import fullButton from '@/components/element/fullButton'
import { BRANCH_WEB_QUEUE_ACCESS_ID , QUEUE_URL } from '../../service/index'

export default {
  name: 'OrderPaidDetail',
  props: ['restaurant_uuid', 'branch_uuid'],
  mixins: [Mixins],
  components: {
    fullButton,
    DrawerEditOrder,
    Gmap
  },
  data(){
    return {
      branch_queue_permission: Object.values(BRANCH_WEB_QUEUE_ACCESS_ID),
      queueUrl:QUEUE_URL,
      confirm_drawer: false,
      isCopy: false,
      isOpenDrawerBankDetail: false,
      isOpenDrawerEditOrder: false,
      confirm: false,
      status: true,
      origTotalAmount: 0,
      totalAmount: 0,
      isOpenDrawerUploadStatus: false,
      DataFiles: null,
      LastedimageSlipURL: '',
      currency: this.$store.getters.currency
    }
  },
  methods:{
    closeUploadSlip () {
      this.isOpenDrawerBankDetail = false
    },
    closeOrder() {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/order/history` })
    },
    confirmEditOrder () {
      this.$store.dispatch('setConfirmEditOrder', {
        restaurant_uuid: this.BranchDetail.restaurantId,
        branch_uuid: this.BranchDetail.id,
        orderId: this.$route.query.oid
      }).then((response) => {
        if(response) {
          this.isOpenDrawerEditOrder = true
          this.confirm = true
        } else {
          this.isOpenDrawerEditOrder = false
          this.confirm = false
        }
      })
    },
    toggle_edit_order () {
      // Reset Last Order
      this.$store.dispatch('getLastOrder', { oid: this.$route.query.oid })
      this.isOpenDrawerEditOrder = !this.isOpenDrawerEditOrder
    },
    toggle_edit_order_transfer () {
      this.isOpenDrawerBankDetail = !this.isOpenDrawerBankDetail
      this.isOpenDrawerUploadStatus = false
    },
    async repeatPaymentQR () {
      const loading = await this.$store.dispatch('startLoading')
      setTimeout(() => {
        loading.close()
      }, 2000)
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/qr`, query: { 'rcp': this.LastOrder.orderCode, 'unq': this.LastOrder.uniqueOrderCode, 'uid': this.LastOrder.branchUUID } })
    },
    async openQueuePage () {
      let branch_id = btoa(this.LastOrder.branch_id)
      let delivery_id = btoa(this.LastOrder.deliveryId)
      const loading = await this.$store.dispatch('startLoading')
      setTimeout(() => {
        loading.close()
      }, 2000)
      let url = `${this.queueUrl}/${branch_id}/${delivery_id}`
      window.open(url, "_blank")
    },
    openLink(link,custom) {
      if(link){
        if(custom){
          switch (custom.from) {
            case 'line':
              if(custom.action == "contact_branch"){
                window.open(`https://line.me/R/oaMessage/${link}`)
              }
            break;
            default:
              break;
          }
        }else{
          window.open(link)
        }
      }
    },
    // openLink(link, custom) {
    //   if(link){
    //     if(custom){
    //       switch (custom.from) {
    //         case 'line':
    //           if(custom.action == "confirm_order"){
    //             let txt = ""
    //             let lastorder = this.LastOrder
    //             if (lastorder.orderTypeDesc == 'Pickup' && lastorder.paymentType == 18) {
    //               txt = encodeURI(`ออเดอร์รับเองที่ร้าน ${lastorder.orderCode} ชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทางบัตรเครดิตเรียบร้อยแล้ว`)
    //             } else if (lastorder.orderTypeDesc == 'Pickup' && lastorder.paymentType == 17 && lastorder.isPaid == 0) {
    //               txt = encodeURI(`ออเดอร์รับเองที่ร้าน ${lastorder.orderCode} รอชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทาง Qr Code`)
    //             } else if (lastorder.orderTypeDesc == 'Pickup' && lastorder.paymentType == 17 && lastorder.isPaid == 1) {
    //               txt = encodeURI(`ออเดอร์รับเองที่ร้าน ${lastorder.orderCode} ชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทาง Qr Code เรียบร้อยแล้ว`)
    //             } else if (lastorder.orderTypeDesc == 'Delivery' && lastorder.paymentType == 18) {
    //               txt = encodeURI(`ออเดอร์จัดส่งถึงบ้าน ${lastorder.orderCode} ชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทางบัตรเครดิตเรียบร้อยแล้ว`)
    //             } else if (lastorder.orderTypeDesc == 'Delivery' && lastorder.paymentType == 17 && lastorder.isPaid == 0) {
    //               txt = encodeURI(`ออเดอร์จัดส่งถึงบ้าน ${lastorder.orderCode} รอชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทาง Qr Code`)
    //             } else if (lastorder.orderTypeDesc == 'Delivery' && lastorder.paymentType == 17 && lastorder.isPaid == 1) {
    //               txt = encodeURI(`ออเดอร์จัดส่งถึงบ้าน ${lastorder.orderCode} ชำระเงิน ${this.price_format(lastorder.totalAmount)} บาท ผ่านทาง Qr Code เรียบร้อยแล้ว`)
    //             } else if (lastorder.orderTypeDesc == 'Pickup' && lastorder.paymentType == 1) {
    //               txt = encodeURI(`ออเดอร์รับเองที่ร้าน ${lastorder.orderCode} ต้องการชำระเงินปลายทาง ${this.price_format(lastorder.totalAmount)} บาท`)
    //             } else if (lastorder.orderTypeDesc == 'Delivery' && lastorder.paymentType == 1) {
    //               txt = encodeURI(`ออเดอร์จัดส่งถึงบ้าน ${lastorder.orderCode} ต้องการชำระเงินปลายทาง ${this.price_format(lastorder.totalAmount)} บาท`)
    //             } else {
    //               let txt_send = (lastorder.orderTypeDesc == 'Delivery') ? 'ออเดอร์จัดส่งถึงบ้าน' : 'ออเดอร์รับเองที่ร้าน'
    //               if (lastorder.paymentType == 2 && lastorder.confirmEditFlag == 1 && Number(lastorder.origTotalAmount) < Number(lastorder.totalAmount)) {
    //                 txt = encodeURI(`${txt_send} ${lastorder.orderCode} ต้องการแจ้งโอนเงิน ${this.price_format(lastorder.diffTotalAmount)} บาท`)
    //               } else {
    //                 txt = encodeURI(`${txt_send} ${lastorder.orderCode} ต้องการแจ้งโอนเงิน ${this.price_format(lastorder.totalAmount)} บาท`)
    //               }
    //             }
    //             window.open(`https://line.me/R/oaMessage/${link}/?${txt}`)
    //           }else{
    //             window.open(`https://line.me/R/oaMessage/${link}`)
    //           }
    //         break;
    //         default:
    //           break;
    //       }
    //     }else{
    //       window.open(link)
    //     }
    //   }
    // },
    copyHandle(str){
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = str;                                 // Set its value to the string that you want copied
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';                 
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
      const selected =            
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el);                  // Remove the <textarea> element
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected); 
      }
      if (!this.isCopy) {
        this.$notify({
          title: this.$t('pageCheckout.copyaccount'),
          customClass: 'copy-notify',
          iconClass: 'copy-notification',
          duration: 4000,
          type: 'success',
          showClose: false
        });
        this.isCopy = true
        setTimeout(() => {
          this.isCopy = false
        }, 4000);
      }
    },
    dropImageSlip () {
      document.getElementById('imageSlip').value = ''
      this.$refs.imageSlip.click()
    },
    previewFile (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (files[0].size > 2097152) { // limit 2MB OR 2097152 Byte And JPEG OR PNG ///
        this.$notify({
          title: this.$t('pageOrderHistory.textsliptranfer1'),
          customClass: 'fs-notify fs-error-notify',
          iconClass: 'fs-notification',
          duration: 3000,
          type: 'warning',
          showClose: false
        })
      } else {
        if (files[0].type == 'image/jpeg' || files[0].type == 'image/jpg' || files[0].type == 'image/png') {
          // Preview Image Before Upload
          this.DataFiles = files[0]
          this.setPreviewImage(this.DataFiles)
        } else {
          this.$notify({
            title: this.$t('pageOrderHistory.textsliptranfer2'),
            customClass: 'fs-notify fs-error-notify',
            iconClass: 'fs-notification',
            duration: 3000,
            type: 'warning',
            showClose: false
          })
        }
      }
    },
    setPreviewImage (files) {
      const preview = document.getElementById('previewSlip')
      const reader = new FileReader();
      reader.addEventListener("load", function () {
        // convert image file to base64 string
        preview.src = reader.result
        // set w/h image file
        preview.style.width = "100%"
        preview.style.height = "100%"
      }, false);

      if (files) {
        // this.imageSlipURL = files
        reader.readAsDataURL(files)
      }
    },
    async confirmUploadSlip (file) {
      if(file === null) {

        this.$notify({
          title: this.$t('pageOrderHistory.textuploadslip2'),
          customClass: 'fs-notify fs-error-notify',
          iconClass: 'fs-notification',
          duration: 3000,
          type: 'error',
          showClose: false
        })

      } else {

        const loading = await this.$store.dispatch('startLoading')

        var bodyFormData = new FormData()
        bodyFormData.set('image_slip', file)

        this.$store.dispatch('setConfirmUploadSlip', {
          orderId: this.$route.query.oid,
          data: bodyFormData
        }).then((response) => {
          if(response) {
            loading.close()
            this.isOpenDrawerUploadStatus = true
          } else {
            loading.close()
            this.$notify({
              title: this.$t('pageOrderHistory.uploaderror'),
              customClass: 'fs-notify fs-error-notify',
              iconClass: 'fs-notification',
              duration: 3000,
              type: 'error',
              showClose: false
            })
          }
        })

      }
    }
  },
  mounted () {
    // Set Top Page
    window.scrollTo(0,0)
    // console.log(this.branch_queue_permission)
    // console.log("Queue Permission : "+this.branch_queue_permission.includes(this.LastOrder.branch_id))
  },
  computed: {
    distanceInfo: function() {
			return this.$store.getters.DistanceInfo
    },
    LastOrder () {
      let LastOrder = this.$store.getters.LastOrder
      if (LastOrder) {
        this.origTotalAmount = Number(LastOrder.origTotalAmount)
        this.totalAmount = Number(LastOrder.totalAmount)
        // this.slipStatus = true
        // Set Image Slip
        // this.slipStatus = LastOrder.slipStatus
        this.LastedimageSlipURL = (LastOrder.slipStatus) ? 'https://images.foodstory.co/' + LastOrder.slipImageKey : ''
      }
      return this.$store.getters.LastOrder
    },
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    contactCol () {
      let contact_list = 0
      if (this.BranchDetail.fbMessenger) {
        contact_list++
      }
      if (this.BranchDetail.lineName) {
        contact_list++
      }
      if (this.BranchDetail.phone) {
        contact_list++
      }
      return 24 / (contact_list || 1)
    },
    confirmCol () {
      let contact_list = 0
      if (this.BranchDetail.fbMessenger) {
        contact_list++
      }
      if (this.BranchDetail.lineName) {
        contact_list++
      }
      return 24 / (contact_list || 1)
    }
  },
  watch: {
    isOpenDrawerBankDetail (value) {
      if (!value && this.isOpenDrawerUploadStatus) {
        this.$store.dispatch('getLastOrder', { oid: this.$route.query.oid })
        this.isOpenDrawerBankDetail = false
        this.DataFiles = null
      }
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/order/OrderPaidDetail.vue